module.exports = __webpack_public_path__ + "img/fleeca.0f9764c4.png";